import React from 'react'
import PropTypes from 'prop-types'

import ProjectClientListItem from "./ProjectClientListItem";

const ProjectClientList = (props) => {

    const {project_id, clients, onRemove} = props

    if(!clients) return null

    return(
        <div className="d-flex flex-column">
            {
                clients.map((client, index) => <ProjectClientListItem
                    project_id={project_id}
                    client={client}/>)
            }
        </div>

    )

}

ProjectClientList.propTypes = {
    project_id: PropTypes.string.isRequired,
    clients: PropTypes.array,
}

export default ProjectClientList